<template>
  <div id="stripe-sepa">
    <el-alert
      v-if="error"
      type="error"
      title="An error has occurred with your IBAN"
      description="You must enter the Account Holder (name) and Email for debits notifications"
      :closable="false"
    />

    <el-card v-if="showDetails" :shadow="shadow">
      <h5 slot="header">Billing address :</h5>
      <Details
        :address.sync="details.address"
        :name.sync="details.name"
        :email.sync="details.email"
        size="mini"
        show-business
      />
    </el-card>

    <el-card :shadow="shadow">
      <h5 slot="header">IBAN information :</h5>
      <div ref="iban"></div>
    </el-card>

    <p>
      <small>
        By providing your IBAN and confirming this payment, you are authorizing RunStack and Stripe,
        our payment service provider, to send instructions to your bank to debit your account and your
        bank to debit your account in accordance with those instructions. You are entitled to a refund
        from your bank under the terms and conditions of your agreement with your bank. A refund must
        be claimed within 8 weeks starting from the date on which your account was debited.<br>
        You agree to RunStack's
        <a href="https://runstack.io/terms" target="_blank">Terms of Service</a> and
        <a href="https://runstack.io/privacy" target="_blank">Privacy Policy</a>.
      </small>
    </p>

    <p>
      <el-button
        type="primary"
        :loading="loading"
        @click.prevent="add"
      >
        Enable SEPA Debit
      </el-button>

      <el-button
        v-if="showCancel"
        type="default"
        @click="$emit('cancel')"
      >
        Cancel
      </el-button>
    </p>
  </div>
</template>

<script>
import Details from './Details'
// eslint-disable-next-line no-undef
const stripe = Stripe(process.env.VUE_APP_STRIPE_KEY)
const elements = stripe.elements()
let stripeIban

export default {
  props: {
    shadow: {
      type: String,
      default: 'always'
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showDetails: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Details
  },
  data () {
    return {
      error: false,
      loading: false,
      details: {
        name: undefined,
        email: undefined,
        address: undefined
      }
    }
  },
  mounted () {
    stripeIban = elements.getElement('iban') || elements.create('iban', {
      supportedCountries: ['SEPA'],
      placeholderCountry: this.$root.language.country,
      style: {
        base: {
          color: '#000'
        }
      }
    })
    stripeIban.mount(this.$refs.iban)
  },
  beforeDestroy () {
    if (stripeIban) {
      stripeIban.clear()
    }
  },
  methods: {
    add () {
      this.loading = true
      this.error = null

      this.$store.dispatch('createPaymentMethod', this.details).then((intent) => {
        return stripe.confirmSepaDebitSetup(intent.secret, {
          payment_method: {
            type: 'sepa_debit',
            sepa_debit: stripeIban,
            billing_details: this.details
          }
        }).then((result) => {
          this.error = result.error

          if (result.error) {
            this.loading = false
            this.$forceUpdate()
          } else {
            return this.$store.dispatch('savePaymentMethod', result.setupIntent)
              .then(() => this.$emit('save'))
          }
        })
      }).catch(() => {
        this.error = true
        this.loading = false
        this.$forceUpdate()
      })
    }
  }
}
</script>

<style lang="scss">
  @import "../../theme";

  #stripe-sepa {
    .el-alert {
      margin-bottom: 20px;
    }
    .el-card {
      max-width: 400px;
      margin-bottom: 20px;
    }
    .el-card__header {
      padding-top: 0;
      padding-bottom: 0;
    }
    .powered {
      float: right;
      width: calc(100% - 400px);
      max-height: 30px;
      padding: 1px 15px;
    }
    .card {
      height: 30px
    }
    a {
      color: $--color-text-primary;
    }
  }
</style>
